import { FC, memo } from 'react'
import { Box, RadioProps, useRadio } from '@chakra-ui/react'

type Props = RadioProps & {
  children: string
}

const RadioCard: FC<Props> = ({ children, ...props }) => {
  const { getInputProps, getRadioProps } = useRadio(props)

  const input = getInputProps()
  const checkbox = getRadioProps()

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        tabIndex={0}
        className="accessible"
        textAlign="center"
        p={1.5}
        rounded="sm"
        bg="light"
        borderWidth="1px"
        borderColor="borderColor"
        _hover={{ borderColor: 'lightPrimary', bg: 'lightPrimary' }}
        _checked={{
          bg: 'primary',
          color: 'light',
        }}
      >
        {children.replace(':', '')}
      </Box>
    </Box>
  )
}

export default memo(RadioCard)
